import { Link, NavLink, useLocation } from 'react-router-dom'
import { LIVESTREAMS_ENABLED, TRAFFIC_TAB_ENABLED } from '../config/features'

export function AppHeader() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.delete('view')
  params.delete('camera')
  const liveActive = location.pathname === '/livestreams' || (location.pathname.startsWith('/stations/') && new URLSearchParams(location.search).get('view') === 'live')
  return <header className="app-header">
    <NavLink className="brand-lockup" to={{ pathname: '/', search: params.toString() }} aria-label="Weighing Station Oversight home"><span className="institution-logos" aria-label="Government organisations">
      <img src="/branding/government-of-punjab.png" alt="Government of Punjab" width="50" height="50" />
      <img src="/branding/communication-and-works.png" alt="Communication and Works Department" width="54" height="54" />
      <img src="/branding/rams.png" alt="Road Asset Management System" width="54" height="48" />
    </span><span>Weighing Station Oversight</span></NavLink>
    <nav aria-label="Primary navigation" className="primary-nav">
      <NavLink to={{ pathname: '/', search: params.toString() }} end>Network</NavLink>
      <NavLink to={{ pathname: '/records', search: params.toString() }}>Records</NavLink>
      {TRAFFIC_TAB_ENABLED && <NavLink to={{ pathname: '/traffic', search: params.toString() }}>Traffic</NavLink>}
      {LIVESTREAMS_ENABLED && <Link to={{ pathname: '/livestreams', search: params.toString() }} className={liveActive ? 'active' : undefined} aria-current={liveActive ? 'page' : undefined}>Livestreams</Link>}
      <NavLink to={{ pathname: '/downloads', search: params.toString() }}>Downloads</NavLink>
      <a href={__DASHBOARD_ADMIN_URL__} title="Open secure station administration">Admin</a>
    </nav>
  </header>
}
